import { AppColors } from "@/styles/colors";
import { Button, Flex, Text } from "@chakra-ui/react";
import { Download, Paperclip, RefreshCw } from "lucide-react";

interface Props {
  idArchivoAdjunto?: number | null;
  nombreArchivo?: string | null;
  urlArchivo?: string | null;
  archivoDisponible?: boolean;
  canWrite: boolean;
  loading: boolean;
  onAttach: () => void;
  onReplace: () => void;
}

export const VoleoRequestFileCard = ({
  idArchivoAdjunto,
  nombreArchivo,
  urlArchivo,
  archivoDisponible,
  canWrite,
  loading,
  onAttach,
  onReplace,
}: Props) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      padding="16px 24px"
      border={`1px dashed ${AppColors.WHITE_BORDER_1}`}
      borderRadius="12px"
    >
      {!idArchivoAdjunto ? (
        <>
          <Text fontSize="14px" color={AppColors.GRAY_TEXT}>
            No hay archivo de prescripción adjunto.
          </Text>
          {canWrite && (
            <Button
              variant="outline"
              paddingX="12px"
              height="32px"
              onClick={onAttach}
              loading={loading}
            >
              <Paperclip size={16} />
              <Text fontWeight={600} fontSize="14px">
                Adjuntar archivo
              </Text>
            </Button>
          )}
        </>
      ) : archivoDisponible ? (
        <>
          <Text fontSize="14px">{nombreArchivo}</Text>
          <Flex gap="8px">
            <Button
              paddingX="12px"
              height="32px"
              bgColor={AppColors.BLACK_TEXT_SECONDARY}
              disabled={!urlArchivo}
              onClick={() => urlArchivo && window.open(urlArchivo, "_blank")}
            >
              <Download size={16} color={AppColors.WHITE_SECONDARY} />
              <Text fontWeight={600} fontSize="14px" color={AppColors.WHITE_SECONDARY}>
                Descargar
              </Text>
            </Button>
            {canWrite && (
              <Button
                variant="outline"
                paddingX="12px"
                height="32px"
                onClick={onReplace}
                loading={loading}
                disabled={loading}
              >
                <RefreshCw size={16} />
                <Text fontWeight={600} fontSize="14px">
                  Reemplazar archivo
                </Text>
              </Button>
            )}
          </Flex>
        </>
      ) : (
        <>
          <Text fontSize="14px" color={AppColors.LIGHT_GRAY_TEXT}>
            {nombreArchivo}
          </Text>
          {canWrite && (
            <Button
              variant="outline"
              paddingX="12px"
              height="32px"
              onClick={onReplace}
              loading={loading}
              disabled={loading}
            >
              <RefreshCw size={16} />
              <Text fontWeight={600} fontSize="14px">
                Reemplazar archivo
              </Text>
            </Button>
          )}
        </>
      )}
    </Flex>
  );
};
